(function (global, factory) {
  if (typeof module === "object" && typeof module.exports === "object") factory(exports, require("react"), require("prop-types"), require("katex"));else if (typeof define === "function" && define.amd) define(["exports", "react", "prop-types", "katex"], factory);else if (global = typeof globalThis !== "undefined" ? globalThis : global || self) factory(global.index = {}, global.react, global.propTypes, global.katex);
})(this, function (exports, _react, _propTypes, _katex) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _export(target, all) {
    for (var name in all) {
      Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
      });
    }
  }

  _export(exports, {
    BlockMath: function BlockMath() {
      return _BlockMath;
    },
    InlineMath: function InlineMath() {
      return _InlineMath;
    }
  });

  _react = /*#__PURE__*/_interopRequireWildcard(_react);
  _propTypes = /*#__PURE__*/_interopRequireDefault(_propTypes);
  _katex = /*#__PURE__*/_interopRequireDefault(_katex);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }

  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }

    var cache = _getRequireWildcardCache(nodeInterop);

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj.default = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }
  /**
  * @typedef {import("react").ReactNode} ReactNode
  *
  *
  * @callback ErrorRenderer
  * @param {Error} error
  * @returns {ReactNode}
  *
  *
  * @typedef {object} MathComponentPropsWithMath
  * @property {string} math
  * @property {ReactNode=} children
  * @property {string=} errorColor
  * @property {ErrorRenderer=} renderError
  *
  *
  * @typedef {object} MathComponentPropsWithChildren
  * @property {string=} math
  * @property {ReactNode} children
  * @property {string=} errorColor
  * @property {ErrorRenderer=} renderError
  *
  * @typedef {MathComponentPropsWithMath | MathComponentPropsWithChildren} MathComponentProps
  */


  var createMathComponent = function createMathComponent(Component, _ref) {
    var displayMode = _ref.displayMode;

    /**
    *
    * @param {MathComponentProps} props
    * @returns {ReactNode}
    */
    var MathComponent = function MathComponent(_ref2) {
      var children = _ref2.children,
          errorColor = _ref2.errorColor,
          math = _ref2.math,
          renderError = _ref2.renderError;
      var formula = math !== null && math !== void 0 ? math : children;

      var _ref3 = (0, _react.useMemo)(function () {
        try {
          var _html = _katex.default.renderToString(formula, {
            displayMode,
            errorColor,
            throwOnError: !!renderError
          });

          return {
            html: _html,
            error: undefined
          };
        } catch (error) {
          if (error instanceof _katex.default.ParseError || error instanceof TypeError) {
            return {
              error
            };
          }

          throw error;
        }
      }, [formula, errorColor, renderError]),
          html = _ref3.html,
          error = _ref3.error;

      if (error) {
        return renderError ? renderError(error) : /*#__PURE__*/_react.default.createElement(Component, {
          html: "".concat(error.message)
        });
      }

      return /*#__PURE__*/_react.default.createElement(Component, {
        html: html
      });
    };

    MathComponent.propTypes = {
      children: _propTypes.default.string,
      errorColor: _propTypes.default.string,
      math: _propTypes.default.string,
      renderError: _propTypes.default.func
    };
    return MathComponent;
  };

  var InternalPathComponentPropTypes = {
    html: _propTypes.default.string.isRequired
  };

  var InternalBlockMath = function InternalBlockMath(_ref4) {
    var html = _ref4.html;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "react-katex",
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  };

  InternalBlockMath.propTypes = InternalPathComponentPropTypes;

  var InternalInlineMath = function InternalInlineMath(_ref5) {
    var html = _ref5.html;
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "react-katex",
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  };

  InternalInlineMath.propTypes = InternalPathComponentPropTypes;

  var _BlockMath = createMathComponent(InternalBlockMath, {
    displayMode: true
  });

  var _InlineMath = createMathComponent(InternalInlineMath, {
    displayMode: false
  });
}); //# sourceMappingURL=react-katex.js.map